export default {
  custom_allergen: {
    placeholder: 'Lisää oma vaihtoehto',
  },
  buttons: {
    add: 'Lisää',
  },
};
